export default __webpack_public_path__ + "static/media/image6.4c0332e1.png";